//繁体中文
module.exports = {
	common: {
		common_0: "加载中",
		common_1: "提示",
		common_2: "取消",
		common_3: "确定",
		common_4: "预览",
		common_5: "操作成功",
		common_6: "网络连接失败",
		common_7: "房源添加成功!",
		common_8: "客戶添加成功!",

		common_InOffset: "下拉刷新",
		common_OutOffset: "释放刷新",
		common_Loading: "加载中...",
		common_NoMore: "没有更多了"
	},
	Message: {
		Message_01: "資料保存成功。",
		Message_02: "資料保存失敗。",
		Message_03: "没有满足条件的数据。",
		Message_04: "打印的数据超过了1万条,请追加检索条件。",
		Message_05: "此欄必須輸入。",
        Message_06: "请求失败。",
		Message_07: "请求成功。",
		Message_08: "数据保存失败。",
		Message_09: "数据保存成功。",
		Message_10: "保存成功。 您要继续添加吗？",
		Message_11: "提示",
		Message_12: "您确定要删除吗？",
		Message_13: "提示",
		Message_14: "删除失败",
		Message_15: "删除成功",
		Message_16: "请您在列表中勾选您要删除的用户信息",
	},
	home: {
		home_0: "由於在一定時間內無法確認操作，從安全性的角度考慮退出了。請再次登錄。",
		home_1: "錯誤",
		home_2: "確定",
		home_3: "請求失敗"
	},
	login: {
		login_0: "PO+S管理",
		login_1: "会社ID",
		login_2: "登录ID",
		login_3: "密码",
		login_4: "请输入公司ID",
		login_5: "请输入登录ID",
		login_6: "请输入密码",
		login_7: "没有输入数据",
		login_8: "不能登录。请重新看一下输入的内容。",
		login_9: "登录成功",
		login_10: "互联网和无线局域网(wifi)连接不上",		
		login_11: "日本語",
		login_12: "簡体字",
		login_13: "繁体字",
		login_14:"登錄",
		login_15:"改变语言失败"
	},
	header: {
		header_0: "PO+S管理平台",
		header_1: "日本語",
		header_2: "简体中文",
		header_3: "繁体中文",
		header_4: "English",
		header_5: "取消全屏",
		header_6: "全屏",
		header_7: "有",
		header_8: "条未读消息",
		header_9: "消息中心",
		header_10: "个人资料",
		header_11: "退出登录"
	},
	tags: {
		tags_0: "标签选项",
		tags_1: "关闭其他",
		tags_2: "关闭所有"
	},
	sidebar: {
		sidebar_0: "系统首页",
		sidebar_1: "菜单管理",
		sidebar_2: "角色管理",
		sidebar_3: "用户管理",
		sidebar_4: "会社管理",
		
		sidebar_5: "商品移动",
		sidebar_6: "商品移动出库处理",
		sidebar_7: "商品移動履歴",
		sidebar_8: "角色管理",
		

	},
	forgetpwd: {
		forgetpwd_0: "找回密码",
		forgetpwd_1: "请输入邮箱",
		forgetpwd_2: "请输入验证码",
		forgetpwd_3: "请输入6-18位新密码",
		forgetpwd_4: "密码长度在6-18位之间",
		forgetpwd_5: "获取验证码",
		forgetpwd_6: "与输入密码不一致",
		forgetpwd_7: "确定",
		forgetpwd_8: "想起来了!",
		forgetpwd_9: "直接登录",
		forgetpwd_10: "验证码不能为空",
		forgetpwd_11: "请输入正确邮箱格式",
		forgetpwd_12: "秒后重新获取",
		forgetpwd_13: "重新获取",
		forgetpwd_14: "验证码错误",
		forgetpwd_15: "登录成功",
		forgetpwd_16: "请输入账号和密码",
		forgetpwd_17: "邮箱不能为空",
		forgetpwd_18: "验证码不正确",
		forgetpwd_19: "修改成功",
		forgetpwd_20: "请先注册该邮箱号",
		forgetpwd_21: "验证码已经超时",
		forgetpwd_22: "修改失败",
		forgetpwd_23: "请重复6-18位新密码",
		forgetpwd_24: "邮箱与验证码不匹配",
		forgetpwd_25: "验证码必须是6位",
		forgetpwd_26: "获取中"
	},
	
	
	Analysisinventorycurrent: {
		Analysisinventorycurrent_0:"在庫統計（現在庫）",
		Analysisinventorycurrent_1:"選項",
		Analysisinventorycurrent_2:"店鋪",
		Analysisinventorycurrent_3:"分類",
		Analysisinventorycurrent_4:"大分類",
		Analysisinventorycurrent_5:"中分類",
		Analysisinventorycurrent_6:"小分類",
		Analysisinventorycurrent_7:"製造商",
		Analysisinventorycurrent_8:"JAN",
		Analysisinventorycurrent_9:"品番",
		Analysisinventorycurrent_10:"品名1",
		Analysisinventorycurrent_11:"品名2",
		Analysisinventorycurrent_12:"内容1",
		Analysisinventorycurrent_13:"内容2",
		Analysisinventorycurrent_14:"組1",
		Analysisinventorycurrent_15:"組2",
		Analysisinventorycurrent_16:"最終入庫日",
		Analysisinventorycurrent_17:"供應商",
		Analysisinventorycurrent_18:"蒐索",
		Analysisinventorycurrent_19:"請求失敗",
		Analysisinventorycurrent_20:"暫無數據",
		Analysisinventorycurrent_21:"請選擇最終入庫日",
		Analysisinventorycurrent_22: "數據超過10000條，請追加檢索條件",
		Analysisinventorycurrent_23: "數據超過30000條，請追加檢索條件",
		Analysisinventorycurrent_24:"昇冪",
		Analysisinventorycurrent_25:"降序",
	},
	Analysisinventoryeom: {
		Analysisinventoryeom_0:"在庫統計（月末在庫）",
		Analysisinventoryeom_1:"選項",
		Analysisinventoryeom_2:"店鋪",
		Analysisinventoryeom_3:"分類",
		Analysisinventoryeom_4:"大分類",
		Analysisinventoryeom_5:"中分類",
		Analysisinventoryeom_6:"小分類",
		Analysisinventoryeom_7:"廠家",
		Analysisinventoryeom_8:"JAN",
		Analysisinventoryeom_9:"品番",
		Analysisinventoryeom_10:"品名1",
		Analysisinventoryeom_11:"品名2",
		Analysisinventoryeom_12:"内容1",
		Analysisinventoryeom_13:"内容2",
		Analysisinventoryeom_14:"組1",
		Analysisinventoryeom_15:"組2",
		Analysisinventoryeom_16:"年月",
		Analysisinventoryeom_17:"蒐索",
		Analysisinventoryeom_18:"請求失敗",
		Analysisinventoryeom_19:"昇冪",
		Analysisinventoryeom_20:"降序",
		Analysisinventoryeom_21:"請選擇年月",
		Analysisinventoryeom_22:"暫無數據",
		Analysisinventoryeom_23:"請選擇店鋪",
		Analysisinventoryeom_24: "數據超過10000條，請追加檢索條件",
		Analysisinventoryeom_25: "數據超過30000條，請追加檢索條件",
	},

	menusList: {
		menusList_0: "選單管理",
		menusList_1: "請蒐索選單名稱",
		menusList_2: "蒐索",
		menusList_3: "新增",
		menusList_4: "拼命加載中",
		menusList_5: "選單名稱",
		menusList_6:"圖標",
		menusList_7:"類型",
		menusList_8:"目錄",
		menusList_9:"選單",
		menusList_10:"按鈕",
		menusList_11:"上級選單",
		menusList_12:"選單URL",
		menusList_13:"授權標識",
		menusList_14:"排序",
		menusList_15:"操作",
		menusList_16:"編輯",
		menusList_17:"删除",
		menusList_18:"新增選單",
		menusList_19:"編輯選單",
		menusList_20:"選單類型：",
		menusList_21:"名稱：",
		menusList_22:"頂級選單",
		menusList_23:"授權標識：",
		menusList_24:"選單路由：",
		 
		menusList_25:"URL格式：",
		menusList_26:"1.常規業務開發的功能URL,如用戶管理,pages目錄下頁面路徑為/users/usersList,此處填寫/users/usersList。",
		menusList_27:"2.嵌套外部網頁,如通過選單打開百度網頁,此處填寫http://www.baidu.com,http://不可省略。",
		menusList_28:"示例：用戶管理：/users/usersList嵌套百度：http://www.baidu.com嵌套網頁：http://127.0.0.1：8000",
		menusList_29:"排序編號：",
		menusList_30:"功能表圖示：",
		menusList_31:"功能表圖示名稱（如：el-icon-s-home）",
		menusList_32:"返回",
		menusList_33:"確認",
		menusList_34:"名稱不能為空",
		menusList_35:"請求失敗",
		menusList_36:"您確定要删除嗎？",
		menusList_37:"提示",
		menusList_38:"删除失敗",
		menusList_39:"删除成功",
		menusList_40:"確認提交嗎？",
		menusList_41:"選單名稱不能重複新增",
		menusList_42:"操作失敗",
		menusList_43:"操作成功",
		menusList_44:"上級選單："
	},
	Dashboard: {
		Dashboard_0: "系统首页",
		Dashboard_1: "本周店铺数量",
		Dashboard_2: "本周导游数量",
		Dashboard_3: "本周代理商数量",
		Dashboard_4: "本周订单成交量",
		Dashboard_5: "同比上周",
		Dashboard_6: "消息",
		Dashboard_7: "查看更多",
		Dashboard_8: "订单销售金额统计",
		Dashboard_9: "近7天成交统计",
		Dashboard_10: "近3天",
		Dashboard_11: "近7天",
		Dashboard_12: "近30天",
		Dashboard_13: "日期",
		Dashboard_14: "销售金额",
		Dashboard_15: "近3天成交统计",
		Dashboard_16: "近30天成交统计",
		Dashboard_17: "注册统计",
		Dashboard_18: "导游",
		Dashboard_19: "店铺",
		Dashboard_20: "代理商",
		Dashboard_21: "请求失败",
		Dashboard_22: "店铺类型",
	},
	T13011: {
		T13011_0: "伝票ID",
		T13011_1: "担当者",
		T13011_2: "入力日",
		T13011_3: "入荷伝票ID",
		T13011_4: "移動元",
		T13011_5: "備考",
		T13011_6: "移動先",
		T13011_7: "JAN ",
		T13011_8: "数量合計",
		T13011_9: "メーカー",
		T13011_10: "大分類 ",
		T13011_11: "中分類",
		T13011_12: "小分類 ",
		T13011_13: "品番",
		T13011_14: "品名",
		T13011_15: "品名2",
		T13011_16: "属性1 ",
		T13011_17: "属性2",
		T13011_18: "属性3 ",
		T13011_19: "標準価格",
		T13011_20: "数量",
		T13011_21: "金額",
		T13011_22: "備考",
		T13011_23: "金額",
		T13011_24: "数据保存成功。",
		T13011_25: "数据保存失败。",
		T13011_26: "请求失败",
		T13011_27: "商品移动",
		T13011_28: "盘点中,无法进行商品调拨。\n盘点结束后,请再次录入。",
		T13011_29: "无数据",
		T13011_30: "運送業者",
		T13011_31: "送り状番号",
		T13011_32: "输入的 JAN 不存在。", 
		T13011_33: "表单验证失败",
		T13011_34: "リセット",
		T13011_35: "登 録",		
		T13011_36: "即時入庫",
		T13011_37: "删除",
	},
	T13021: {
		T13021_0: "商品移动 ",		
		T13021_1:"メーカー",
		T13021_2:"移動元",
		T13021_3:"伝票ID",
		T13021_4:"状態",
		T13021_5:"JAN",
		T13021_6:"移動先",
		T13021_7:"キーワード",
		T13021_8:"備考",
		T13021_9:"品番",
		T13021_10:"処理日時",
		T13021_11:"品名",
		T13021_12:"移動伝票ID",
		T13021_13:"移動状態 ",
		T13021_14:"移動元 ",
		T13021_15:"移動先 ",
		T13021_16:"入力者 ",
		T13021_17:"入力日 ",
		T13021_18:"発送者 ",
		T13021_19:"発送日 ",
		T13021_20:"入庫者 ",
		T13021_21: "入庫日 ",
		T13021_22: "送り状ID ",
		T13021_23:"リセット",
		T13021_24:"导出Excel",
		T13021_25:"",
		T13021_26:"搜索",
		T13021_27:"发送",
		T13021_28:"入库",
		T13021_29:"再发行",
		T13021_30:"照会",
		T13021_31:"编辑",
		T13021_32:"删除",
		T13021_33:"品名",
		T13021_34:"削除も表示",
		T13021_35:"自店に関係あるものだけ表示",
		T13021_36: "開始日付",
		T13021_37: "終了日付",
		T13021_38: "请求失败",
		T13021_39: "操作",
		T13021_40: "您确定要操作吗？",
		T13021_41: "提示",
		T13021_42: "操作失败",
		T13021_43: "操作成功",
		T13021_table0: "JAN",
		T13021_table1: "メーカー",		
		T13021_table2: "大分類",
		T13021_table3: "中分類",
		T13021_table4: "小分類",		
		T13021_table5: "品番",
		T13021_table6: "品名",
		T13021_table7: "品名2",		
		T13021_table8: "標準価格",
		T13021_table9: "数量",
		T13021_table10: "金額",		
		T13021_table11: "備考",
		T13021_table12: "删除标志",
		T13021_table13: "社内JAN",
		T13021_44: "此操作将导出excel文件, 是否继续?",
		T13021_45: "确定",
		T13021_46: "取消",
		T13021_47: "移動元店舗",
		T13021_48: "移動先店舗",
		T13021_49: "ブランド",
		T13021_50: "サイズ",
		T13021_51: "カラー",
		T13021_52: "移動リスト",	
		T13021_53: "請選擇明細行。",		
		},	
	NavEdit:{
			NavEdit_0:"菜单管理",
			NavEdit_1:"上級導航",
			NavEdit_2:"排序",
			NavEdit_3:"顯示",
			NavEdit_4:"調用別名",
			NavEdit_5:"導航名稱(日本)",
			NavEdit_6:"導航名稱(中国)",
			NavEdit_7:"導航名稱(台湾)",
			NavEdit_8:"副標題",
			NavEdit_9:"連結位址",
			NavEdit_10:"備註說明",
			NavEdit_11:"許可權分配",
			NavEdit_12:['显示(Show)','查看(View)','添加(Add)','修改(Edit)','删除(Delete)','审核(Audit)','回复(Reply)','确认(Confirm)','取消(Cancel)','作废(Invalid)','生成(Build)','安装(Instal)','卸载(Unload)','备份(Back)','还原(Restore)','替换(Replace)'],
			NavEdit_13:"*数字,越小越向前",
			NavEdit_14:"隐藏后不显示在界面导航菜单中",
			NavEdit_15:"权限控制名称,只允许字母、数字、下划线,与栏目管理-栏目名称相对应。",
			NavEdit_16:"*导航标题,100字符内",
			NavEdit_17:"非必填,当导航拥有两个名称时使用",
			NavEdit_18:"当前管理目录,有子导航不用填",
			NavEdit_19:"非必填,可为空",	
			NavEdit_20:"必填,不能为空",
			NavEdit_21:"保存",
			NavEdit_22:"返回",
			NavEdit_23:'请求失败',
			NavEdit_24:'保存成功',
			NavEdit_25:'保存失败',
			NavEdit_26:'表单验证失败',
		},
		NavList:{
			NavList_0:"菜單管理",
			NavList_1:"新增",
			NavList_2:"保存",
			NavList_3:"調用別名",
			NavList_4:"標題",
			NavList_5:"顯示",
			NavList_6:"排序",
			NavList_7:"操作",
			NavList_8:"添加子級",
			NavList_9:"修改",
			NavList_10:"删除",
		},		
	Role_List: {
			Role_List: "角色管理",
			Role_List_0: "新增",
			Role_List_1: "全選",
			Role_List_2: "删除",		
			Role_List_3: "選擇",
			Role_List_4: "角色名稱",
			Role_List_5: "類型",
			Role_List_6: "操作",
			Role_List_7: "系統用戶",
			Role_List_8: "修改",
			Role_List_9: "角色人員",
			Role_List_10: "Admin",
			Role_List_11: "",
			Role_List_12: "",
			Role_List_13: "",
			Role_List_14: "",
		},	
	Role_Edit:{
		Role_Edit_0:"角色管理",
		Role_Edit_1:"角色類型",
		Role_Edit_2:"角色名(日本)",
		Role_Edit_3:"角色名(中国)",
		Role_Edit_4:"角色名(台灣)",
		Role_Edit_5:"側菜單",
		Role_Edit_6:"全選",
		Role_Edit_7:"權限",
		Role_Edit_8:"保存",
		Role_Edit_9:"返回",
		Role_Edit_10:"管理者權限",
		Role_Edit_11:"請輸入角色名(日本)。",
		Role_Edit_12:"請輸入役割名(中国)。",
		Role_Edit_13:"請輸入役割名(台湾)。",
		Role_Edit_14:"請選擇角色類型。",
		Role_Edit_15:"表單驗證失敗",
	},
	AnalysisGoldstat: {
		AnalysisGoldstat_0: "升序",
		AnalysisGoldstat_1: "降序"
	},
	Analysissales: {
		Analysissales_0: "升序",
		Analysissales_1: "降序"
	},
	Analysissalesec: {
		Analysissalesec_0: "升序",
		Analysissalesec_1: "降序"
	},
	Analysismove: {
		Analysismove_0: "升序",
		Analysismove_1: "降序"
	},
	Managers: {
		Managers_0: "選擇角色名稱",
		Managers_1: "職員代碼/姓名/郵箱地址",
		Managers_2: "账户名",
		Managers_3: "姓名",
		Managers_4: "電話號",
		Managers_5: "角色名",
		Managers_6: "登陸時間",
		Managers_7: "狀態",
		Managers_8: "操作",
		Managers_9: "變更",
		Managers_10: "可以删除嗎？",
		Managers_11: "提示",
		Managers_12: "確定",
		Managers_13: "取消",
		Managers_14: "删除成功",
		Managers_15: "已取消",
		Managers_16: "正常",
		Managers_17: "禁止",
		Managers_18: "請求失敗",
		Managers_19: "刪除失敗",
		Managers_20: "用户管理"	,
		Managers_21: "削除",
		Managers_22:"請選擇要刪除的信息",
		
		Managers_23: "選擇角色名稱",
		Managers_24: "請輸入內容",
		Managers_25: "保存",
		Managers_26: "返回",
		Managers_27: "保存成功",
		Managers_28: "保存失敗",
		Managers_29: "請求失敗",	
		Managers_30: "用户管理",
		Managers_31: "提示",
		Managers_32: "确认提交吗？",
	},
	
	Category:{
		Category_0:"",
		Category_1:"銷售金額",
		Category_2:"去年銷售率",
		Category_3:"盈利金額",
		Category_4:"盈利率",
		Category_5:"去年盈利率",
		Category_6:"退還金額",
		Category_7:"退還率",
		Category_8:"進貨金額",
		Category_9:"加價率",
		Category_10:"在庫金額",
		Category_11:"蒐索",
	}
}
